export default class ProductGroupApiModel {
  constructor(rawModel) {
    this.Key = rawModel?.Key || null
    this.InternalName = rawModel?.InternalName || null
    this.Price = rawModel?.Price || null
    this.AvailableOnline = rawModel?.AvailableOnline || null
    this.Products = rawModel?.Products?.map(x => new ProdutGroupProductApiModel(x)) || []
  }
}

class ProdutGroupProductApiModel {
  constructor(rawModel) {
    this.Key = rawModel?.Key || null
    this.ProductKey = rawModel?.ProductKey || null
    this.ProductNameInternal = rawModel?.ProductNameInternal || null
    this.ProgramOrder = rawModel?.ProgramOrder || null
    this.Price = rawModel?.Price || 0
    this.BasePrice = rawModel?.BasePrice || 0
    this.PriceType = rawModel?.PriceType || null // [ NotSet, PerPerson, PerTeam, PerResource ]
    this.PriceOffset = rawModel?.PriceOffset || 0
    this.Type = rawModel?.Type || null
    this.ProductNeedsToBeScheduled = rawModel?.ProductNeedsToBeScheduled || null
    this.ProductQuantity = rawModel?.ProductQuantity || null
    this.PriceIncludesTax = rawModel?.PriceIncludesTax || null
  }
}
